var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { BenefitCardMW, BenefitCardFullWidthDTW, BenefitCardHalfWidthDTW, ButtonHireTradesPeople, ButtonPostAJob, } from '../../../shared/rewards-hub';
var constants = {
    title: "Path To Pro Network",
    subtitle: (React.createElement(React.Fragment, null,
        "Hire the skilled tradespeople you need to grow your business. Search for jobseekers, post new jobs, and review your live openings.",
        ' ',
        React.createElement("a", { className: "sui-underline", href: "/path-to-pro-network" }, "Learn more"))),
    iconUrl: 'https://assets.thdstatic.com/images/v1/path-to-pro/Pro_Talent.svg',
};
export var PathToProCTA = function (_a) {
    var isMobile = _a.isMobile;
    return !isMobile ? (React.createElement("div", { className: "sui-flex sui-gap-3 sui-w-full" },
        React.createElement(ButtonHireTradesPeople, null),
        React.createElement(ButtonPostAJob, null))) : (React.createElement("div", { className: "sui-w-full" },
        React.createElement("div", { className: "sui-mb-3 sui-mt-2" },
            React.createElement(ButtonHireTradesPeople, null)),
        React.createElement(ButtonPostAJob, null)));
};
var PathToProMW = function (props) {
    var isLocked = props.isLocked;
    var data = __assign(__assign({}, props), { isLocked: isLocked, iconUrl: constants.iconUrl, title: constants.title, subtitle: constants.subtitle, footerButton: React.createElement(PathToProCTA, __assign({ isMobile: true }, props)) });
    return React.createElement(BenefitCardMW, __assign({}, data));
};
var PathToProFullWidthDTW = function (props) {
    var isLocked = props.isLocked;
    var data = __assign(__assign({}, props), { isLocked: isLocked, iconUrl: constants.iconUrl, title: constants.title, subtitle: constants.subtitle, content: React.createElement(PathToProCTA, __assign({ isMobile: true }, props)) });
    return React.createElement(BenefitCardFullWidthDTW, __assign({}, data));
};
var PathToProHalfWidthDTW = function (props) {
    var isLocked = props.isLocked;
    var data = __assign(__assign({}, props), { isLocked: isLocked, iconUrl: constants.iconUrl, title: constants.title, subtitle: constants.subtitle, footerButton: React.createElement(PathToProCTA, __assign({ isMobile: true }, props)) });
    return React.createElement(BenefitCardHalfWidthDTW, __assign({}, data));
};
export var PathToPro = function (props) {
    var isMobile = props.isMobile, isLocked = props.isLocked, fullWidth = props.fullWidth;
    var mockProp = props.mockProp; // TODO: Remove after demo
    var data = { isMobile: isMobile, isLocked: isLocked };
    if (isMobile)
        return React.createElement(PathToProMW, __assign({}, data));
    // if (fullWidth) return <PathToProHalfWidthDTW {...data} />;
    // return <PathToProHalfWidthDTW {...data} />;
    // For Demo
    if (fullWidth)
        return React.createElement(PathToProFullWidthDTW, __assign({}, data, { mockProp: mockProp }));
    return React.createElement(PathToProHalfWidthDTW, __assign({}, data, { mockProp: mockProp }));
};
